/**
 * HTML5 Dialog Modal component with accessibility features
 */

export function initModal() {
  // Get all modal triggers
  const modalTriggers = document.querySelectorAll("[data-modal-trigger]")

  modalTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault()
      const modalId = trigger.getAttribute("data-modal-trigger")
      openModal(modalId)
    })
  })

  // Get all modal close buttons
  const modalCloseButtons = document.querySelectorAll(".dialog__close")

  modalCloseButtons.forEach((button) => {
    button.addEventListener("click", () => {
      closeModal(button.closest("dialog"))
    })
  })

  // Handle form submissions in dialogs
  const dialogForms = document.querySelectorAll("dialog form")
  dialogForms.forEach((form) => {
    form.addEventListener("submit", (_e) => {
      // Don't prevent default - let the form submit normally
      const dialog = form.closest("dialog")
      if (dialog) {
        // Close the dialog on submit
        // The form submission will continue in the background
        // and the user will be redirected to the factsheet download
        closeModal(dialog)
      }
    })
  })

  // Close modal with ESC key (native dialog behavior)
  // Additional close button handling already covered above
}

const openModal = (modalId) => {
  const dialog = document.getElementById(modalId)
  if (!dialog) return

  // Show dialog using native HTML5 dialog API
  dialog.showModal()

  // Focus on close button for accessibility
  const closeButton = dialog.querySelector(".dialog__close")
  if (closeButton) {
    closeButton.focus()
  }
}

const closeModal = (dialog) => {
  if (!dialog) return

  // Close dialog using native HTML5 dialog API
  dialog.close()

  // Return focus to trigger button if it exists
  const triggerId = dialog.getAttribute("data-modal-id")
  if (triggerId) {
    const trigger = document.querySelector(
      `[data-modal-trigger="${triggerId}"]`,
    )
    if (trigger) {
      trigger.focus()
    }
  }
}
